import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import _ from 'lodash';

export default function canvasFormReportReducer(state = initialstate.canvasFormReport, action) {
	switch (action.type) {
		case types.GET_CANVAS_FORM_REPORT:
			if (action.response) {
				return action.response?.data;
			} else {
				return [];
			}
		default:
			return state;
	}
}

export function controlFormReportReducer(state = initialstate.controlFormReport, action) {
	switch (action.type) {
		case types.GET_CONTROL_FORM_REPORT:
			if (action.response) {
				return action.response;
			} else {
				return [];
			}
		default:
			return state;
	}
}
